
import { AdminDashboard } from '@/screens'

import AdminLayout from '@/layout/AdminLayout.vue'

import entities from './entities'
import schemaBuilder from './schemaBuilder'
import imports from './imports'
import users from './users'
import audit from './audit'

export default meta => [
    {
        path: '/admin',
        name: 'Admin',
        component: AdminLayout,
        redirect: { name: 'AdminDashboard' },
        children: [
            {
                path: '',
                name: 'AdminDashboard',
                component: AdminDashboard,
                meta,
            },
            ...entities(meta),
            ...schemaBuilder(meta),
            ...imports(meta),
            ...users(meta),
            ...audit(meta),
        ],
    },
]
